export const getIconSize = (size: string = '' ) => {
    if (size === 'lg') {
      return 24;
    }
    if (size === 'xl') {
      return 32;
    }
    
    return 16
  };
  